import { Tab } from "bootstrap";
import React, { useEffect, useState } from "react";
import { Tabs } from "react-bootstrap";
import ReactDOM from "react-dom";
import { getQuotation, loadFeeCodes } from "../Biddetails/biddetailsServices";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import InvoiceBidCalculation from "../InvoiceBidDetails/InvoiceBidCalculation";
import { calculateTotalCharges } from "../InvoiceBidDetails/InvoiceBidDetailsServices";
import { PackageDisplay } from "../common/restService/tmServices";
import "./Authorization.scss";

function DetailDialog({ detailDialogData = {}, gridData = [] }) {
  const {
    docType,
    freightOrder,
    rfqNumber,
    quoteNumber,
    docTypeDesc,
    statusDesc,
  } = detailDialogData;
  const [generalDetails, setGeneralDetails] = useState(null);
  const [response, setResponse] = useState(null);
  const [response2, setResponse2] = useState(null);
  const [loading, setloading] = useState(true);
  const [multipleTab, setMultipleTab] = useState(false);
  const [tabType, setTabType] = useState("QUOTE");
  const [selected, setSelected] = useState(0);
  const [chargeDesc, setChargeDesc] = useState([]);
  const [totalCharges, setTotalCharges] = useState({
    totalContractedCharges: 0,
    totalNonContractedCharges: 0,
    totalQuotationCharges: 0,
  });
  const [totalChargesInvoice, setTotalChargesInvoice] = useState({
    totalContractedCharges: 0,
    totalNonContractedCharges: 0,
    totalQuotationCharges: 0,
  });

  useEffect(() => {
    async function getData() {
      setloading(true);

      // General Details
      const generalDetailsData = gridData.find(
        (data) => data["freightOrder"] === freightOrder
      );
      console.log(generalDetailsData);
      setGeneralDetails(generalDetailsData);

      if (
        docType !== undefined &&
        freightOrder !== undefined &&
        rfqNumber !== undefined &&
        quoteNumber !== undefined &&
        docTypeDesc !== undefined &&
        statusDesc !== undefined
      ) {
        let _chargeDesc = await loadFeeCodes();
        let _tabType = "QUOTE";
        if (statusDesc === "SUBMITTED") {
          if (
            docTypeDesc === "Intel Shipment Request" ||
            docTypeDesc === "Multi-Bid Request"
          ) {
            _tabType = "QUOTE";
          } else if (docTypeDesc === "Invoice Adjustment Request") {
            _tabType = "INVOICE";
          }
        } else if (statusDesc === "Re-Submitted" || statusDesc === "Awaiting Approval" || statusDesc === "Awaiting Re-Approval") {
          if (
            docTypeDesc === "Intel Shipment Request" ||
            docTypeDesc === "Multi-Bid Request"
          ) {
            _tabType = "QUOTE";
            setMultipleTab(true);
          } else if (docTypeDesc === "Invoice Adjustment Request") {
            _tabType = "INVOICE";
          }
        } else if (statusDesc === "Sent Back by Approver") {
          _tabType = "QUOTE";
          setMultipleTab(true);
        }

        const data = [
          {
            orderType: docType, // docType
            foNum: freightOrder, // freightOrder
            rfqNum: rfqNumber, // rfqNumber
            quotationNum: quoteNumber, // quoteNumber
            docType: _tabType, // no the in data depends on button clicked - Quote or invoice
          },
        ];
        let tempRes = await getQuotation(data);
        tempRes = tempRes["searchRes"];
        // console.log(tempRes);
        // debugger
        if (tempRes !== undefined) {
          tempRes = tempRes.map((res) => ({
            ...res,
            chargeDescription: _chargeDesc.find(
              (res1) => res["feeCode"] === res1["feeCode"]
            )["description"],
            totalPrice: (
              Number(res["ratePerUnit"]) * Number(res["units"])
            ).toFixed(2),
            chargePerUnit: res["ratePerUnit"],
            quantity: res["units"],
            contractedYN: res["contracted"],
          }));
        }
        setResponse(tempRes);
        setTabType(_tabType);
        setChargeDesc(_chargeDesc);

        if (multipleTab === true) {
          const data2 = [
            {
              orderType: docType, // docType
              foNum: freightOrder, // freightOrder
              rfqNum: rfqNumber, // rfqNumber
              quotationNum: quoteNumber, // quoteNumber
              docType: "INVOICE", // no the in data depends on button clicked - Quote or invoice
            },
          ];
          let tempRes2 = await getQuotation(data2);
          tempRes2 = tempRes2["searchRes"];
          if (tempRes2 !== undefined) {
            tempRes2 = tempRes2.map((res) => ({
              ...res,
              chargeDescription: _chargeDesc.find(
                (res1) => res["feeCode"] === res1["feeCode"]
              )["description"],
              totalPrice: (
                Number(res["ratePerUnit"]) * Number(res["units"])
              ).toFixed(2),
              chargePerUnit: res["ratePerUnit"],
              quantity: res["units"],
              contractedYN: res["contracted"],
            }));
          }
          setResponse2(tempRes2);
        }
      }
      setloading(false);

    }
    getData();
  }, [
    docType,
    freightOrder,
    rfqNumber,
    quoteNumber,
    docTypeDesc,
    statusDesc,
    multipleTab,
    gridData,
  ]);

  useEffect(() => {
    // debugger
    if (response !== undefined && response !== null) {
      setTotalCharges(
        calculateTotalCharges(JSON.parse(JSON.stringify(response)))
      );
      if (multipleTab) {
        if (response2 !== undefined && response2 !== null) {
          setTotalChargesInvoice(
            calculateTotalCharges(JSON.parse(JSON.stringify(response2)))
          );
        }
      }
    }
  }, [multipleTab, response, response2]);

  function handleSelect(e) {
    setSelected(e.selected);
  }

  return (
    <>
      {loading && <span>Loading...</span>}

      <div className="detail-dialog">
        <TabStrip selected={selected} onSelect={handleSelect}>
          {generalDetails && !loading && (
            <TabStripTab title="General Details">
              <div className="general-detail-table">
                <table>                  
                  <tr>
                    <th>SCAC Code</th>
                    <td>{generalDetails["carrierScac"]}</td>
                  </tr>
                  <tr>
                    <th>Port Origin </th>
                    <td>{generalDetails["sourceLocid"]}</td>
                  </tr>
                  <tr>
                    <th>Port Destination</th>
                    <td>{generalDetails["destLocid"]}</td>
                  </tr>
                  <tr>
                    <th>Requested Pick-up Date</th>
                    <td>{generalDetails["plannedShipmentStart"]}</td>
                  </tr>
                  <tr>
                    <th>Service Code</th>
                    <td>{generalDetails["ymovType"]}</td>
                  </tr>
                  <tr>
                    <th>Commodity Code</th>
                    <td>{generalDetails["yccode"]}</td>
                  </tr>
                  <tr>
                    <th>Transportation Mode</th>
                    <td>{generalDetails["trmodcod"]}</td>
                  </tr>
                  <tr>
                    <th>TPT</th>
                    <td>{generalDetails["ytpt"]}</td>
                  </tr>
                  <tr>
                    <th>Intel Reference Number</th>
                    <td>{generalDetails["btdId"]}</td>
                  </tr>
                  <tr>
                    <th>Special Instructions</th>
                    <td>{generalDetails["specialInstructions"]}</td>
                  </tr>
                  <tr>
                    <th>Incoterms</th>
                    <td>{generalDetails["incClassCode"]}</td>
                  </tr>
                  <tr>
                    <th>NCRM Reason Code</th>
                    <td>{generalDetails["yncrmReasonCode"]}</td>
                  </tr>
                  <tr>
                    <th>NCRM Comments</th>
                    <td>{generalDetails["comment"]}</td>
                  </tr>
                  <tr>
                    <th>Total Shipment Weight</th>
                    <td>
                      {Number(generalDetails["totalGrossWeight"]).toFixed(2) +
                        " " +
                        generalDetails["grossWeightMeasure"]}
                    </td>
                  </tr>
                  <tr>
                    <th>Quotation Number</th>
                    <td>{generalDetails["quoteNumber"]}</td>
                  </tr>
                  <tr>
                    <th>Request For Quote</th>
                    <td>{generalDetails["rfqNumber"]}</td>
                  </tr>
                  {!(statusDesc == "Awaiting Re-Approval" || statusDesc == "Awaiting Approval") && (
                  <tr>
                    <th>Next Approver</th>
                    <td>{generalDetails["toBeApprovedBy"]}</td>
                  </tr>)}
                  {(statusDesc == "Awaiting Re-Approval" || statusDesc == "Awaiting Approval") && (
                  <tr>
                    <th>Authorizer Comment</th>
                    <td>{generalDetails["remarks"]}</td>
                  </tr>)}
                </table>
                {/* <pre>{JSON.stringify(generalDetails, null, 2)}</pre> */}
              </div>
            </TabStripTab>
          )}

          {response && !loading && (
            <TabStripTab
              title={tabType === "QUOTE" ? "Bid Details" : "Invoice Details"}
            >
              <div
                style={{ width: "1200px", height: "auto", overflow: "auto" }}
              >
                <Grid
                  ScrollMode="scrollable"
                  style={{
                    maxHeight: "325px"
                  }}
                  data={response}
                >
                  <Column field="feeCode" title="Fee Code" />
                  <Column
                    field="chargeDescription"
                    title="Charge Description"
                    width="150px"
                  />
                  <Column
                    field="contracted"
                    title="Contracted124 Y/N"
                    width="130px"
                  />
                  <Column
                    field="tariffType"
                    title="Tariff Type"
                    width="150px"
                  />
                  <Column field="units" title="Quantity" width="100px" />
                  <Column
                    field="ratePerUnit"
                    title="Charge Per Unit"
                    width="100px"
                  />
                  <Column
                    field="totalPrice"
                    title="Total Price"
                    width="100px"
                  />
                  <Column field="currencyCode" title="Currency" width="100px" />
                  <Column field="comments" title="Comments" />
                </Grid>
                {/* <pre>{JSON.stringify(response, null, 2)}</pre> */}

                <InvoiceBidCalculation
                  totalCharges={totalCharges}
                  currencySelected={response[0]["currencyCode"]}
                />
              </div>
            </TabStripTab>
          )}

          {multipleTab === true && response2 && (
            <TabStripTab title="Invoice Details">
              <div
                style={{ width: "1200px", height: "auto", overflow: "auto" }}
              >
                <Grid
                  ScrollMode="scrollable"
                  style={{
                    maxHeight: "325px"
                  }}
                  data={response2}
                >
                  <Column field="feeCode" title="Fee Code" />
                  <Column
                    field="chargeDescription"
                    title="Charge Description"
                    width="150px"
                  />
                  <Column
                    field="contracted"
                    title="Contracted Y/N"
                    width="110px"
                  />
                  <Column
                    field="tariffType"
                    title="Tariff Type"
                    width="150px"
                  />
                  <Column field="units" title="Quantity" width="100px" />
                  <Column
                    field="ratePerUnit"
                    title="Charge Per Unit"
                    width="100px"
                  />
                  <Column
                    field="totalPrice"
                    title="Total Price"
                    width="100px"
                  />
                  <Column field="currencyCode" title="Currency" width="100px" />
                  <Column field="comments" title="Comments" />
                </Grid>

                <InvoiceBidCalculation
                  totalCharges={totalChargesInvoice}
                  currencySelected={response2[0]["currencyCode"]}
                />
                {/* <pre>{JSON.stringify(response2, null, 2)}</pre> */}
              </div>
            </TabStripTab>
          )}
        </TabStrip>
      </div>
    </>
  );
}

export default DetailDialog;
